/**
 * Parses a CSS string into a React CSSProperties object
 *
 * @param cssString - CSS string like "border: 1px solid red; margin: 10px;"
 * @returns React.CSSProperties object
 *
 * @example
 * parseCssString("border: 1px solid red; margin: 10px;")
 * // Returns: { border: "1px solid red", margin: "10px" }
 */
export const parseCssString = (cssString: string): React.CSSProperties => {
  const style: Record<string, string> = {};

  cssString.split(';').forEach((declaration) => {
    const [property, value] = declaration.split(':').map((s) => s.trim());
    if (property && value) {
      const camelProperty = property.replace(/-([a-z])/g, (_, letter) =>
        letter.toUpperCase(),
      );
      style[camelProperty] = value;
    }
  });

  return style as React.CSSProperties;
};
